import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';

interface CheckboxProps {
    label: string;
    checkboxId: string;
    checked?: boolean; // Dışarıdan kontrol edilebilecek prop
    disabled?: boolean; // Checkbox'u devre dışı bırakmak için
    required?: boolean; // Zorunlu alan olup olmadığını belirlemek için
    errorMessage?: string; // Hata mesajı
    onChange?: (checked: boolean) => void; // Durum değişikliklerinde tetiklenecek callback
}

export interface CheckboxHandle {
    isChecked: () => boolean; // Checkbox'ın mevcut durumunu kontrol etme
    setChecked: (checked: boolean) => void; // Checkbox'ı dışarıdan işaretleme
}

const Checkbox = forwardRef<CheckboxHandle, CheckboxProps>(({
    label,
    checkboxId,
    checked,
    disabled = false,
    required = false,
    errorMessage = 'Bu alan zorunludur',
    onChange,
}, ref) => {
    const [isChecked, setIsChecked] = useState(checked || false);
    const [isValid, setIsValid] = useState(true);

    // Dışarıdan checked prop'u güncellendiğinde state'i güncelle
    useEffect(() => {
        if (checked !== undefined) {
            setIsChecked(checked);
        }
    }, [checked]);

    // forwardRef ile ref üzerinden kullanılabilecek metodları tanımlıyoruz
    useImperativeHandle(ref, () => ({
        isChecked: () => isChecked, // Checkbox'ın durumunu döndürür
        setChecked: (checked: boolean) => setIsChecked(checked), // Checkbox'ı dışarıdan işaretler veya kaldırır
    }));

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newChecked = event.target.checked;
        setIsChecked(newChecked); // İç state'i güncelle

        if (onChange) {
            onChange(newChecked); // Parent component'e durumu bildir
        }

        // Eğer zorunluysa ve işaretlenmemişse, hata göster
        if (required && !newChecked) {
            setIsValid(false);
        } else {
            setIsValid(true);
        }
    };

    return (
        <div className="form-group">
            <div className="form-check">
                <input
                    id={checkboxId}
                    type="checkbox"
                    className={`form-check-input ${!isValid ? 'is-invalid' : ''}`} // Hata varsa stil ekle
                    checked={isChecked} // Checkbox durumu
                    disabled={disabled} // Devre dışı bırakılmışsa
                    onChange={handleChange} // Tıklama ile durumu değiştir
                />
                <label className="form-check-label" htmlFor={checkboxId}>
                    {label}
                </label>
            </div>
            {!isValid && (
                <div className="invalid-feedback">
                    {errorMessage}
                </div>
            )}
        </div>
    );
});

export default Checkbox;
